import { useState, useEffect } from "react";
import elisFoto from "./imagens/ELIS.jpeg";
import microBladingFoto from "./imagens/microblading.jpeg";

/* ─────────────────────────────────────────────
   GLOBAL STYLES
───────────────────────────────────────────── */
const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400;1,600&family=Jost:wght@200;300;400;500;600&display=swap');
  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
  :root {
    --gold: #C9A84C; --gold-light: #E8CC7A; --gold-pale: #F5E9C8;
    --black: #080808; --dark: #111111; --dark2: #1A1A1A;
    --off-white: #FAFAF8; --white: #FFFFFF;
    --gray: #6B6B6B; --light-gray: #E8E8E8; --mid-gray: #AAAAAA;
  }
  html { scroll-behavior: smooth; }
  body { font-family: 'Jost', sans-serif; background: var(--off-white); color: var(--black); overflow-x: hidden; }
  .serif { font-family: 'Cormorant Garamond', serif; }
  @keyframes fadeUp { from { opacity:0; transform:translateY(30px); } to { opacity:1; transform:translateY(0); } }
  @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
  @keyframes marquee { from { transform:translateX(0); } to { transform:translateX(-50%); } }
  @keyframes pulse { 0%,100% { opacity:0.6; } 50% { opacity:1; } }
  @keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }
  ::-webkit-scrollbar { width:4px; }
  ::-webkit-scrollbar-track { background:var(--black); }
  ::-webkit-scrollbar-thumb { background:var(--gold); }
`;

const LOGO_SRC = "data:image/jpeg;base64,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";
const LOGO_FILTER = "invert(1) sepia(1) saturate(3) hue-rotate(8deg) brightness(1.3)";

/* ─── RESPONSIVE HOOK ─── */
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const treatmentCategories = [
  {
    id:1, icon:"✦", category:"Sobrancelhas",
    items:[
      { name:"Design de Sobrancelhas", price:"12€" },
      { name:"Design de Sobrancelhas com Henna", price:"20€" },
      { name:"Design de Sobrancelhas com Tonalizante", price:"20€" },
      { name:"Microblading", price:"120€" },
      { name:"Shadow", price:"120€" },
      { name:"Shadow Line", price:"120€" },
    ]
  },
  {
    id:2, icon:"〇", category:"Olhos",
    items:[
      { name:"Eyeliner Superior", price:"80€" },
      { name:"Eyeliner Inferior", price:"80€" },
    ]
  },
  {
    id:3, icon:"◇", category:"Lábios",
    items:[
      { name:"Micropigmentação Labial", price:"120€" },
      { name:"Neutralização Labial", price:"120€" },
      { name:"Revitalização Labial", price:"120€" },
      { name:"Hidragloss Labial", price:"30€" },
    ]
  },
  {
    id:4, icon:"❋", category:"Pestanas",
    items:[
      { name:"Lift de Pestanas", price:"27€" },
    ]
  },
  {
    id:5, icon:"◈", category:"Tratamentos Faciais",
    items:[
      { name:"Dermaplaning", price:"25€" },
    ]
  },
  {
    id:6, icon:"⌀", category:"Depilação",
    items:[
      { name:"Buço na Linha", price:"5€" },
    ]
  },
  {
    id:7, icon:"◉", category:"Remoções",
    items:[
      { name:"Remoção de Micropigmentação", price:"a partir de 40€", note:"por sessão" },
      { name:"Remoção de Tatuagem", price:"a partir de 50€" },
    ]
  },
];

const courses = [
  {
    id:1,
    name:"Design de Sobrancelhas — Método Sobrancelhas Perfeitas VIP",
    price:"297€",
    icon:"✦",
    badge:"Formação Completa",
    desc:"Uma formação completa para quem deseja aprender a estruturar sobrancelhas com técnica, harmonia e naturalidade.",
    topics:["Estrutura ideal da sobrancelha","Mapeamento facial profissional","Design de sobrancelhas na prática","Correção de falhas","Aplicação de henna e tonalizante","Atendimento ao cliente","Biossegurança","Postura profissional"],
  },
  {
    id:2,
    name:"Curso de Microblading VIP",
    price:"347€",
    icon:"◈",
    badge:null,
    desc:"Formação voltada para profissionais que desejam aprender a técnica de fios realistas e naturais, proporcionando sobrancelhas definidas e harmoniosas.",
    topics:["Fundamentos da micropigmentação","Estrutura correta da sobrancelha","Mapeamento profissional","Desenho e construção de fios","Técnicas de Microblading","Escolha de pigmentos","Cuidados pré e pós procedimento","Atendimento e avaliação da cliente"],
  },
];

/* ─────────────────────────────────────────────
   SHARED COMPONENTS
───────────────────────────────────────────── */
function Divider() {
  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:16, marginTop:20 }}>
      <div style={{ width:80, height:1, background:"linear-gradient(to right, transparent, var(--gold))" }} />
      <div style={{ width:6, height:6, background:"var(--gold)", transform:"rotate(45deg)" }} />
      <div style={{ width:80, height:1, background:"linear-gradient(to left, transparent, var(--gold))" }} />
    </div>
  );
}

function SectionEyebrow({ children }) {
  return <div style={{ fontSize:20, letterSpacing:"5px", textTransform:"uppercase", color:"var(--gold)", marginBottom:16, fontFamily:"Jost, sans-serif", fontWeight:400 }}>{children}</div>;
}

function GoldBtn({ children, onClick, outline=false, style={} }) {
  const [hov, setHov] = useState(false);
  const base = { fontFamily:"'Jost',sans-serif", fontSize:10, letterSpacing:"4px", textTransform:"uppercase", fontWeight:500, padding:"14px 32px", border:"1px solid var(--gold)", cursor:"pointer", transition:"all 0.3s ease", display:"inline-block", ...style };
  const solid = { background: hov?"transparent":"var(--gold)", color: hov?"var(--gold)":"var(--black)" };
  const outl  = { background: hov?"var(--gold)":"transparent", color: hov?"var(--black)":"var(--gold)" };
  return <button style={{ ...base, ...(outline?outl:solid) }} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)} onClick={onClick}>{children}</button>;
}

/* ─────────────────────────────────────────────
   NAVBAR
───────────────────────────────────────────── */
function Navbar({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  // close menu on page change
  useEffect(() => { setMenuOpen(false); }, [page]);

  const links = [{ id:"home", label:"Home" }, { id:"cursos", label:"Cursos" }, { id:"sobre", label:"Sobre Mim" }];

  const navigate = (id) => { setPage(id); window.scrollTo(0,0); setMenuOpen(false); };

  return (
    <>
      <nav style={{
        position:"fixed", top:0, left:0, right:0, zIndex:1000,
        background: menuOpen ? "var(--black)" : scrolled ? "rgba(8,8,8,0.97)" : "var(--black)",
        borderBottom:`1px solid ${scrolled?"#222":"#1a1a1a"}`,
        backdropFilter:"blur(12px)",
        transition:"all 0.4s ease",
        height:100, overflow:"hidden",
        display:"flex", alignItems:"center", justifyContent:"space-between",
        padding:"0 clamp(20px, 5vw, 72px)",
      }}>
        {/* Logo */}
        <div onClick={() => navigate("home")} style={{ cursor:"pointer", display:"flex", alignItems:"center" }}>
          <img src={LOGO_SRC} alt="Elis Sousa" style={{ height:72, width:72, filter:LOGO_FILTER, objectFit:"cover", display:"block", borderRadius:"50%" }} />
        </div>

        {/* Desktop Links */}
        {!isMobile && (
          <div style={{ display:"flex", gap:48, alignItems:"center" }}>
            {links.map(l => (
              <button key={l.id} onClick={() => navigate(l.id)} style={{
                background:"none", border:"none", cursor:"pointer",
                fontFamily:"'Jost',sans-serif", fontSize:11, fontWeight:400,
                letterSpacing:"3px", textTransform:"uppercase",
                color: page===l.id ? "var(--gold)" : "#999",
                transition:"color 0.3s", position:"relative", padding:"4px 0",
              }}>
                {l.label}
                {page===l.id && <span style={{ position:"absolute", bottom:-2, left:0, right:0, height:1, background:"var(--gold)" }} />}
              </button>
            ))}
            <GoldBtn onClick={() => { setPage("home"); setTimeout(()=>document.getElementById("contacto")?.scrollIntoView({behavior:"smooth"}),100); }}>
              Marcar Reserva
            </GoldBtn>
          </div>
        )}

        {/* Hamburger */}
        {isMobile && (
          <button onClick={() => setMenuOpen(!menuOpen)} style={{
            background:"none", border:"none", cursor:"pointer",
            display:"flex", flexDirection:"column", gap:5, padding:8,
          }}>
            {[0,1,2].map(i => (
              <span key={i} style={{
                display:"block", width:24, height:1.5,
                background: menuOpen && i===1 ? "transparent" : "var(--gold)",
                transition:"all 0.3s",
                transform: menuOpen ? (i===0?"rotate(45deg) translate(4px,4px)": i===2?"rotate(-45deg) translate(4px,-4px)":"none") : "none",
              }} />
            ))}
          </button>
        )}
      </nav>

      {/* Mobile dropdown menu */}
      {isMobile && menuOpen && (
        <div style={{
          position:"fixed", top:100, left:0, right:0, zIndex:999,
          background:"var(--black)", borderBottom:"1px solid #222",
          padding:"24px clamp(20px,5vw,40px) 32px",
          animation:"fadeIn 0.2s ease",
        }}>
          {links.map(l => (
            <button key={l.id} onClick={() => navigate(l.id)} style={{
              display:"block", width:"100%", textAlign:"left",
              background:"none", border:"none", cursor:"pointer",
              fontFamily:"'Jost',sans-serif", fontSize:13, fontWeight:400,
              letterSpacing:"3px", textTransform:"uppercase",
              color: page===l.id ? "var(--gold)" : "#888",
              padding:"14px 0",
              borderBottom:"1px solid #1a1a1a",
            }}>
              {l.label}
            </button>
          ))}
          <div style={{ marginTop:24 }}>
            <GoldBtn style={{ width:"100%", textAlign:"center" }}
              onClick={() => { setPage("home"); setMenuOpen(false); setTimeout(()=>document.getElementById("contacto")?.scrollIntoView({behavior:"smooth"}),100); }}>
              Marcar Reserva
            </GoldBtn>
          </div>
        </div>
      )}
    </>
  );
}

/* ─────────────────────────────────────────────
   MARQUEE
───────────────────────────────────────────── */
function MarqueeStrip() {
  const items = ["Design de Sobrancelhas","Microblading","Shadow Line","Eyeliner Superior","Eyeliner Inferior","Micropigmentação Labial","Neutralização Labial","Lift de Pestanas","Dermaplaning","Remoção de Micropigmentação","Hidragloss Labial","Depilação de Buço","Shadow","Henna de Sobrancelhas"];
  const doubled = [...items,...items];
  return (
    <div style={{ background:"var(--gold)", padding:"13px 0", overflow:"hidden" }}>
      <div style={{ display:"flex", animation:"marquee 22s linear infinite", width:"max-content" }}>
        {doubled.map((item,i) => (
          <span key={i} style={{ fontFamily:"'Jost',sans-serif", fontSize:10, letterSpacing:"4px", textTransform:"uppercase", color:"var(--black)", fontWeight:500, padding:"0 28px", display:"flex", alignItems:"center", gap:16, whiteSpace:"nowrap" }}>
            {item}{i<doubled.length-1 && <span style={{fontSize:5}}>◆</span>}
          </span>
        ))}
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   HOME — HERO
───────────────────────────────────────────── */
function Hero({ setPage }) {
  const isMobile = useIsMobile();
  return (
    <section style={{ background:"var(--black)", minHeight:"100vh", display:"flex", alignItems:"center", paddingTop:100, position:"relative", overflow:"hidden" }}>
      <div style={{ position:"absolute", right:isMobile?"5%":"8%", top:"50%", transform:"translateY(-50%)", width:isMobile?"200px":"380px", height:isMobile?"200px":"380px", border:"1px solid rgba(201,168,76,0.1)", borderRadius:"50%", animation:"spin 40s linear infinite", pointerEvents:"none" }} />
      <div style={{ position:"absolute", right:isMobile?"10%":"12%", top:"50%", transform:"translateY(-50%)", width:isMobile?"120px":"240px", height:isMobile?"120px":"240px", border:"1px solid rgba(201,168,76,0.18)", borderRadius:"50%", pointerEvents:"none" }} />

      <div style={{ padding:isMobile?"60px 24px 80px":"80px clamp(48px,8vw,120px)", maxWidth:720, animation:"fadeUp 0.9s ease forwards" }}>
        <div style={{ fontSize:10, letterSpacing:"5px", textTransform:"uppercase", color:"var(--gold)", marginBottom:28, display:"flex", alignItems:"center", gap:16 }}>
          <span style={{ display:"block", width:40, height:1, background:"var(--gold)" }} />
          Estética Feminina Premium
        </div>
        <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:isMobile?"48px":"clamp(52px,7vw,88px)", fontWeight:300, lineHeight:1.05, color:"#fff", marginBottom:28 }}>
          A Arte de<br />Realçar a sua<br />
          <em style={{ fontStyle:"italic", color:"var(--gold)" }}>Beleza Natural</em>
        </h1>
        <p style={{ fontSize:isMobile?13:14, fontWeight:300, color:"#888", lineHeight:1.9, maxWidth:480, marginBottom:36 }}>
          Tratamentos exclusivos com as técnicas mais avançadas, num ambiente de luxo criado especialmente para si.
        </p>
        <div style={{ display:"flex", gap:12, flexWrap:"wrap" }}>
          <GoldBtn onClick={() => document.getElementById("servicos")?.scrollIntoView({behavior:"smooth"})} style={isMobile?{padding:"12px 22px"}:{}}>Ver Tratamentos</GoldBtn>
          <GoldBtn outline onClick={() => setPage("cursos")} style={isMobile?{padding:"12px 22px"}:{}}>Explorar Cursos</GoldBtn>
        </div>
        <div style={{ display:"flex", gap:isMobile?24:40, marginTop:48, flexWrap:"wrap" }}>
          {[["7 anos","de Experiência"],["2019","Ano de Fundação"],["100%","Dedicação & Paixão"]].map(([n,l]) => (
            <div key={l}>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:isMobile?24:30, color:"var(--gold)", fontWeight:300 }}>{n}</div>
              <div style={{ fontSize:9, letterSpacing:"2px", textTransform:"uppercase", color:"#555", marginTop:4 }}>{l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   TREATMENT CATEGORY CARD
───────────────────────────────────────────── */
function TreatmentCard({ cat, delay=0 }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      style={{ background:hov?"var(--dark2)":"var(--white)", border:"1px solid", borderColor:hov?"var(--gold)":"var(--light-gray)", transition:"all 0.4s ease", transform:hov?"translateY(-4px)":"none", boxShadow:hov?"0 20px 60px rgba(0,0,0,0.12)":"none", animation:`fadeUp 0.6s ease ${delay}s both`, display:"flex", flexDirection:"column" }}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
    >
      <div style={{ height:3, background:"var(--gold)", opacity:hov?1:0.3, transition:"opacity 0.4s" }} />
      <div style={{ padding:"24px 24px 20px" }}>
        {/* Header */}
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:20, paddingBottom:16, borderBottom:`1px solid ${hov?"#2a2a2a":"var(--light-gray)"}`, transition:"border-color 0.3s" }}>
          <div style={{ width:36, height:36, borderRadius:"50%", border:`1px solid ${hov?"var(--gold)":"rgba(201,168,76,0.4)"}`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Cormorant Garamond',serif", fontSize:15, color:"var(--gold)", flexShrink:0, transition:"border-color 0.3s" }}>{cat.icon}</div>
          <h3 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:400, color:hov?"#fff":"var(--black)", lineHeight:1, transition:"color 0.3s" }}>{cat.category}</h3>
        </div>
        {/* Items list */}
        <ul style={{ listStyle:"none", display:"flex", flexDirection:"column", gap:0 }}>
          {cat.items.map((item, i) => (
            <li key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:12, padding:"10px 0", borderBottom:i<cat.items.length-1?`1px solid ${hov?"#1e1e1e":"var(--light-gray)"}`:undefined, transition:"border-color 0.3s" }}>
              <span style={{ fontSize:12, fontWeight:300, color:hov?"#ccc":"var(--black)", lineHeight:1.4, flex:1 }}>
                {item.name}
                {item.note && <span style={{ fontSize:10, color:hov?"#666":"var(--mid-gray)", marginLeft:6, fontStyle:"italic" }}>({item.note})</span>}
              </span>
              <span style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:18, fontWeight:600, color:"var(--gold)", flexShrink:0, whiteSpace:"nowrap" }}>{item.price}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SERVICES SECTION
───────────────────────────────────────────── */
function ServicesSection() {
  const isMobile = useIsMobile();
  return (
    <section id="servicos" style={{ background:"var(--off-white)", padding:isMobile?"60px 20px":"100px clamp(24px,6vw,80px)" }}>
      <div style={{ textAlign:"center", marginBottom:56 }}>
        <SectionEyebrow>Os Nossos Serviços</SectionEyebrow>
        <h2 className="serif" style={{ fontSize:"clamp(32px,5vw,54px)", fontWeight:300, lineHeight:1.1 }}>Tratamentos <em style={{ color:"var(--gold)", fontStyle:"italic" }}>Exclusivos</em></h2>
        <Divider />
        <p style={{ fontSize:13, fontWeight:300, color:"var(--gray)", marginTop:20, maxWidth:480, margin:"20px auto 0", lineHeight:1.8 }}>Especialista em micropigmentação e estética facial de precisão.</p>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:isMobile?"1fr":"repeat(auto-fill, minmax(300px, 1fr))", gap:20 }}>
        {treatmentCategories.map((cat,i) => <TreatmentCard key={cat.id} cat={cat} delay={i*0.07} />)}
      </div>

      {/* Disclaimer */}
      <div style={{ textAlign:"center", marginTop:48, padding:"28px 36px", border:"1px solid rgba(201,168,76,0.35)", background:"rgba(201,168,76,0.06)", maxWidth:620, margin:"48px auto 0" }}>
        <div style={{ fontSize:11, letterSpacing:"4px", textTransform:"uppercase", color:"var(--gold)", marginBottom:12, fontWeight:500 }}>Nota Importante</div>
        <p style={{ fontSize:15, fontWeight:300, color:"var(--black)", lineHeight:1.9 }}>
          Os valores podem variar conforme avaliação profissional.
        </p>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   STATS STRIP
───────────────────────────────────────────── */
function StatsStrip() {
  const isMobile = useIsMobile();
  const stats = [["7 Anos","de Experiência"],["2019","Ano de Fundação"],["100%","Dedicação à Arte"],["✦","Especialista PMU"]];
  return (
    <div style={{ background:"var(--black)", padding:isMobile?"40px 20px":"60px clamp(24px,6vw,80px)", display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)", gap:isMobile?"24px 0":0 }}>
      {stats.map(([n,l],i) => (
        <div key={l} style={{ textAlign:"center", padding:"0 16px", borderRight:!isMobile&&i<3?"1px solid #1e1e1e":"none", borderBottom:isMobile&&i<2?"1px solid #1e1e1e":"none", paddingBottom:isMobile&&i<2?24:0 }}>
          <div className="serif" style={{ fontSize:"clamp(32px,4vw,52px)", fontWeight:300, color:"var(--gold)", lineHeight:1 }}>{n}</div>
          <div style={{ fontSize:10, letterSpacing:"2px", textTransform:"uppercase", color:"#555", marginTop:8, fontWeight:300, lineHeight:1.4 }}>{l}</div>
        </div>
      ))}
    </div>
  );
}

/* ─────────────────────────────────────────────
   FEATURED RITUAL
───────────────────────────────────────────── */
function FeaturedRitual() {
  const isMobile = useIsMobile();
  return (
    <section style={{ display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", minHeight:isMobile?"auto":480 }}>
      <div style={{ position:"relative", overflow:"hidden", minHeight:isMobile?240:320 }}>
        <img
          src={microBladingFoto}
          alt="Microblading de sobrancelhas"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover"
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: isMobile
              ? "linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.5) 100%)"
              : "linear-gradient(90deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)"
          }}
        />
      </div>
      <div style={{ background:"var(--dark)", padding:isMobile?"48px 24px":"72px clamp(36px,5vw,72px)", display:"flex", flexDirection:"column", justifyContent:"center" }}>
        <SectionEyebrow>Tratamento em Destaque</SectionEyebrow>
        <h2 className="serif" style={{ fontSize:"clamp(30px,4vw,48px)", fontWeight:300, color:"#fff", lineHeight:1.15, marginBottom:20 }}>
          Microblading<br /><em style={{ color:"var(--gold)", fontStyle:"italic" }}>Sobrancelhas</em><br />Perfeitas
        </h2>
        <p style={{ fontSize:13, fontWeight:300, color:"#777", lineHeight:1.9, marginBottom:28, maxWidth:400 }}>
          A técnica de micropigmentação que cria fios realistas e naturais, proporcionando sobrancelhas definidas, harmoniosas e duradouras.
        </p>
        <div style={{ display:"flex", alignItems:"baseline", gap:12, marginBottom:28 }}>
          <span style={{ fontSize:11, letterSpacing:"2px", textTransform:"uppercase", color:"#555" }}>A partir de</span>
          <span className="serif" style={{ fontSize:44, fontWeight:300, color:"var(--gold)", lineHeight:1 }}>120€</span>
        </div>
        <GoldBtn outline onClick={() => document.getElementById("contacto")?.scrollIntoView({behavior:"smooth"})}>Reservar Microblading</GoldBtn>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   CONTACT SECTION
───────────────────────────────────────────── */
const MAPS_DIRECTIONS_URL = "https://www.google.com/maps/dir/?api=1&destination=R.+25+de+Abril+n%C2%BA+326+B+Gondomar+Portugal";
 
function ContactSection() {
  const isMobile = useIsMobile();
  const [hovLoc, setHovLoc] = useState(false);
 
  const cards = [
    {
      icon:"📍", title:"Localização",
      lines:["R. 25 de Abril n.º 326/B","Edif. Empório, piso 1, sala 04","4420-068 Gondomar"],
      clickable: true,
    },
    { icon:"📱", title:"WhatsApp", lines:["925 974 687"] },
    { icon:"✉️", title:"Email", lines:["elissousa038@gmail.com"] },
    { icon:"🕐", title:"Horário", lines:["Seg–Sex: 10h–16h30","Sábado: por marcação"] },
  ];
 
  return (
    <section id="contacto" style={{ background:"var(--off-white)", padding:isMobile?"60px 20px":"100px clamp(24px,6vw,80px)" }}>
      <div style={{ textAlign:"center", marginBottom:52 }}>
        <SectionEyebrow>Contacto & Marcações</SectionEyebrow>
        <h2 className="serif" style={{ fontSize:"clamp(28px,4vw,48px)", fontWeight:300 }}>Agende a sua <em style={{ color:"var(--gold)", fontStyle:"italic" }}>Consulta</em></h2>
        <Divider />
      </div>
 
      {/* Cards de contacto */}
      <div style={{ display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)", gap:16, maxWidth:900, margin:"0 auto 40px" }}>
        {cards.map(({ icon, title, lines, clickable }) => {
          const isLoc = clickable;
          return (
            <div
              key={title}
              onClick={isLoc ? () => window.open(MAPS_DIRECTIONS_URL, "_blank") : undefined}
              onMouseEnter={isLoc ? () => setHovLoc(true) : undefined}
              onMouseLeave={isLoc ? () => setHovLoc(false) : undefined}
              style={{
                background: isLoc && hovLoc ? "var(--black)" : "var(--white)",
                border: `1px solid ${isLoc && hovLoc ? "var(--gold)" : "var(--light-gray)"}`,
                padding:"24px 16px",
                textAlign:"center",
                cursor: isLoc ? "pointer" : "default",
                transition:"all 0.3s ease",
              }}
            >
              <div style={{ fontSize:24, marginBottom:10 }}>{icon}</div>
              <div style={{ fontSize:9, letterSpacing:"2px", textTransform:"uppercase", color:"var(--gold)", marginBottom:8 }}>{title}</div>
              {lines.map(l => (
                <div key={l} style={{ fontSize:12, fontWeight:300, color: isLoc && hovLoc ? "#aaa" : "var(--gray)", lineHeight:1.9, transition:"color 0.3s" }}>{l}</div>
              ))}
              {isLoc && (
                <div style={{ fontSize:12, letterSpacing:"2px", textTransform:"uppercase", color:"var(--gold)", marginTop:10, opacity: hovLoc ? 1 : 0.6, transition:"opacity 0.3s" }}>
                  Ver no Google Maps →
                </div>
              )}
            </div>
          );
        })}
      </div>
 
      {/* Redes Sociais */}
      <div style={{ maxWidth:900, margin:"0 auto", borderTop:"1px solid var(--light-gray)", paddingTop:40 }}>
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <SectionEyebrow>Redes Sociais</SectionEyebrow>
          <p style={{ fontSize:18, fontWeight:300, color:"var(--gray)", lineHeight:1.8 }}>Acompanhe o meu trabalho e fique a par de todas as novidades</p>
        </div>
        <div style={{ display:"flex", justifyContent:"center" }}>
          <a
            href="https://www.instagram.com/elissousaoficial?igsh=YWVyZm1rNGNyM2o3"
            target="_blank"
            rel="noreferrer"
            style={{ display:"flex", alignItems:"center", gap:16, background:"var(--white)", border:"1px solid var(--light-gray)", padding:"20px 32px", textDecoration:"none", transition:"all 0.3s ease" }}
            onMouseEnter={e => { e.currentTarget.style.border="1px solid var(--gold)"; e.currentTarget.style.background="var(--black)"; }}
            onMouseLeave={e => { e.currentTarget.style.border="1px solid var(--light-gray)"; e.currentTarget.style.background="var(--white)"; }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
              <circle cx="12" cy="12" r="4"/>
              <circle cx="17.5" cy="6.5" r="1" fill="#C9A84C" stroke="none"/>
            </svg>
            <div>
              <div style={{ fontSize:10, letterSpacing:"3px", textTransform:"uppercase", color:"var(--gold)", marginBottom:4 }}>Instagram</div>
              <div style={{ fontSize:13, fontWeight:300, color:"var(--gray)" }}>@elissousaoficial</div>
            </div>
          </a>
        </div>
      </div>
 
    </section>
  );
}

function HomePage({ setPage }) {
  return (
    <>
      <Hero setPage={setPage} />
      <MarqueeStrip />
      <ServicesSection />
      <StatsStrip />
      <FeaturedRitual />
      <ContactSection />
    </>
  );
}

/* ─────────────────────────────────────────────
   COURSE CARD
───────────────────────────────────────────── */
function CourseCard({ c, delay=0, setPage }) {
  const [open, setOpen] = useState(false);
  const [hov, setHov] = useState(false);
  return (
    <div style={{ background:hov?"var(--dark2)":"var(--white)", border:`1px solid ${hov?"var(--gold)":"var(--light-gray)"}`, transition:"all 0.4s ease", transform:hov?"translateY(-4px)":"none", boxShadow:hov?"0 20px 60px rgba(0,0,0,0.13)":"none", animation:`fadeUp 0.7s ease ${delay}s both`, position:"relative", overflow:"hidden" }}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}>
      {c.badge && <div style={{ position:"absolute", top:16, right:16, background:"var(--gold)", color:"var(--black)", fontSize:9, letterSpacing:"2px", textTransform:"uppercase", padding:"4px 12px", fontWeight:600 }}>{c.badge}</div>}
      <div style={{ height:3, background:"var(--gold)", opacity:hov?1:0.3, transition:"opacity 0.4s" }} />
      <div style={{ padding:"32px 28px 28px" }}>
        {/* Icon + Title */}
        <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:18 }}>
          <div style={{ width:42, height:42, borderRadius:"50%", border:`1px solid ${hov?"var(--gold)":"rgba(201,168,76,0.4)"}`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Cormorant Garamond',serif", fontSize:18, color:"var(--gold)", flexShrink:0, transition:"border-color 0.3s" }}>{c.icon}</div>
          <h3 className="serif" style={{ fontSize:20, fontWeight:400, color:hov?"#fff":"var(--black)", lineHeight:1.25, transition:"color 0.3s", paddingRight:c.badge?90:0 }}>{c.name}</h3>
        </div>
 
        {/* Price highlight */}
        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:18, padding:"14px 18px", background:hov?"rgba(201,168,76,0.08)":"rgba(201,168,76,0.05)", border:"1px solid rgba(201,168,76,0.2)" }}>
          <span style={{ fontSize:10, letterSpacing:"3px", textTransform:"uppercase", color:hov?"#888":"var(--mid-gray)" }}>Valor</span>
          <span className="serif" style={{ fontSize:32, fontWeight:600, color:"var(--gold)", lineHeight:1 }}>{c.price}</span>
        </div>
 
        {/* Description */}
        <p style={{ fontSize:13, fontWeight:300, color:hov?"#bbb":"var(--gray)", lineHeight:1.9, marginBottom:20 }}>{c.desc}</p>
 
        {/* Topics accordion */}
        <button onClick={()=>setOpen(!open)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:10, letterSpacing:"3px", textTransform:"uppercase", color:"var(--gold)", display:"flex", alignItems:"center", gap:8, padding:0, marginBottom:open?16:20, width:"100%" }}>
          <span style={{ display:"inline-block", transition:"transform 0.3s", transform:open?"rotate(90deg)":"none" }}>▶</span>
          {open?"Ocultar conteúdo":"O que você vai aprender"}
        </button>
        {open && (
          <div style={{ animation:"fadeIn 0.3s ease", marginBottom:24 }}>
            <ul style={{ listStyle:"none", display:"flex", flexDirection:"column", gap:10 }}>
              {c.topics.map((t,i)=>(
                <li key={i} style={{ display:"flex", gap:12, fontSize:13, fontWeight:300, color:hov?"#bbb":"var(--black)", lineHeight:1.6, paddingBottom:10, borderBottom:i<c.topics.length-1?`1px solid ${hov?"#1e1e1e":"var(--light-gray)"}`:undefined }}>
                  <span style={{ color:"var(--gold)", flexShrink:0, marginTop:2 }}>◆</span>{t}
                </li>
              ))}
            </ul>
          </div>
        )}
 
        <GoldBtn style={{ width:"100%", textAlign:"center", padding:"14px" }} onClick={() => { setPage("home"); setTimeout(() => document.getElementById("contacto")?.scrollIntoView({behavior:"smooth"}), 100); }}>Quero Saber Mais</GoldBtn>
      </div>
    </div>
  );
}
 
/* ─────────────────────────────────────────────
   COURSES PAGE
───────────────────────────────────────────── */
function CoursesPage({ setPage }) {
  const isMobile = useIsMobile();
  return (
    <div style={{ paddingTop:100 }}>
      {/* Header */}
      <div style={{ background:"var(--black)", padding:isMobile?"60px 24px 52px":"90px clamp(24px,6vw,80px) 80px", position:"relative", overflow:"hidden" }}>
        <div style={{ maxWidth:760, animation:"fadeUp 0.7s ease" }}>
          <SectionEyebrow>Formações Profissionais</SectionEyebrow>
          <h1 className="serif" style={{ fontSize:"clamp(38px,6vw,70px)", fontWeight:300, color:"#fff", lineHeight:1.1, marginBottom:24 }}>
            Formações & <em style={{ color:"var(--gold)", fontStyle:"italic" }}>Especializações</em>
          </h1>
          <p style={{ fontSize:isMobile?14:15, fontWeight:300, color:"#888", lineHeight:1.95, maxWidth:620 }}>
            Se você deseja entrar na área da beleza ou se especializar em sobrancelhas, disponibilizo formações completas com técnicas atualizadas, acompanhamento e todo o conhecimento que aplico diariamente nos meus atendimentos.
          </p>
        </div>
      </div>
 
      <MarqueeStrip />
 
      {/* Cards */}
      <section style={{ padding:isMobile?"52px 20px":"90px clamp(24px,6vw,80px)", background:"var(--off-white)" }}>
        <div style={{ textAlign:"center", marginBottom:56 }}>
          <SectionEyebrow>Escolha a sua Formação</SectionEyebrow>
          <h2 className="serif" style={{ fontSize:"clamp(30px,4vw,48px)", fontWeight:300 }}>Invista no seu <em style={{ color:"var(--gold)", fontStyle:"italic" }}>Futuro</em></h2>
          <Divider />
        </div>
        <div style={{ display:"grid", gridTemplateColumns:isMobile?"1fr":"repeat(auto-fill, minmax(380px, 1fr))", gap:28, maxWidth:900, margin:"0 auto" }}>
          {courses.map((c,i)=><CourseCard key={c.id} c={c} delay={i*0.12} setPage={setPage} />)}
        </div>
      </section>
 
      {/* CTA */}
      <div style={{ background:"var(--black)", padding:isMobile?"48px 24px":"72px clamp(24px,6vw,80px)", display:"flex", flexDirection:"column", alignItems:"center", textAlign:"center", gap:20 }}>
        <SectionEyebrow>Tem Dúvidas?</SectionEyebrow>
        <h2 className="serif" style={{ fontSize:"clamp(24px,3vw,40px)", fontWeight:300, color:"#fff", maxWidth:500 }}>Fale comigo antes de <em style={{ color:"var(--gold)", fontStyle:"italic" }}>decidir</em></h2>
        <p style={{ fontSize:13, fontWeight:300, color:"#666", maxWidth:440, lineHeight:1.8 }}>Estou disponível para esclarecer todas as dúvidas sobre conteúdos e datas.</p>
        <GoldBtn onClick={() => { setPage("home"); setTimeout(() => document.getElementById("contacto")?.scrollIntoView({behavior:"smooth"}), 100); }}>Enviar Mensagem</GoldBtn>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SOBRE MIM PAGE
───────────────────────────────────────────── */
function SobrePage({ setPage }) {
  const isMobile = useIsMobile();
  const procedures = ["Design de sobrancelhas","Design com tonalização e henna","Micropigmentação de sobrancelhas, lábios e olhos","Outros procedimentos de estética facial"];
  return (
    <div style={{ paddingTop:100 }}>
 
      {/* Hero — foto + título */}
      <div style={{ background:"var(--black)", display:"grid", gridTemplateColumns:isMobile?"1fr":"1fr 1fr", minHeight:isMobile?"auto":520 }}>
        {/* Foto placeholder */}
        <div style={{ background:"linear-gradient(160deg,#0f0f0f,#1a1208,#2a2010)", display:"flex", alignItems:"center", justifyContent:"center", position:"relative", minHeight:320, padding:24 }}>
          <div style={{ position:"absolute", inset:0, background:"radial-gradient(ellipse at 40% 50%, rgba(201,168,76,0.06) 0%, transparent 70%)" }} />
          <div style={{ width:"min(260px,75%)", aspectRatio:"3/4", border:"1px solid rgba(201,168,76,0.25)", position:"relative", display:"flex", alignItems:"center", justifyContent:"center", background:"linear-gradient(160deg,#1a1208,#0a0805)" }}>
            {[["top:0,left:0","borderTop:2px solid var(--gold);borderLeft:2px solid var(--gold)"],["top:0,right:0","borderTop:2px solid var(--gold);borderRight:2px solid var(--gold)"],["bottom:0,left:0","borderBottom:2px solid var(--gold);borderLeft:2px solid var(--gold)"],["bottom:0,right:0","borderBottom:2px solid var(--gold);borderRight:2px solid var(--gold)"]].map(([pos,bStyle],i)=>{
              const p2=Object.fromEntries(pos.split(",").map(s=>s.split(":")));
              const b2=Object.fromEntries(bStyle.split(";").map(s=>s.split(":")));
              return <div key={i} style={{ position:"absolute", width:20, height:20, ...p2, ...b2 }} />;
            })}
           <img
            src={elisFoto}
            alt="Elis Sousa"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
          />
            <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"var(--gold)", padding:"10px 16px", margin:"0 -1px" }}>
              <div className="serif" style={{ fontSize:16, color:"var(--black)", fontWeight:600 }}>Elis Sousa</div>
              <div style={{ fontSize:8, letterSpacing:"2px", textTransform:"uppercase", color:"rgba(0,0,0,0.6)", marginTop:2 }}>Especialista em Sobrancelhas & PMU</div>
            </div>
          </div>
        </div>
 
        {/* Título + intro rápida */}
        <div style={{ padding:isMobile?"40px 24px":"72px clamp(36px,5vw,72px)", display:"flex", flexDirection:"column", justifyContent:"center", animation:"fadeUp 0.8s ease" }}>
          <SectionEyebrow>Minha Trajetória</SectionEyebrow>
          <h1 className="serif" style={{ fontSize:"clamp(30px,4vw,52px)", fontWeight:300, color:"#fff", lineHeight:1.1, marginBottom:24 }}>
            Vivo de<br /><em style={{ color:"var(--gold)", fontStyle:"italic" }}>Sobrancelhas</em>
          </h1>
          <p style={{ fontSize:13, fontWeight:300, color:"#999", lineHeight:2, marginBottom:28 }}>
            Casada, mãe de duas filhas, morando em Portugal — e apaixonada por transformar olhares e elevar a autoestima de cada mulher que passa pelo meu espaço.
          </p>
          <div style={{ display:"flex", gap:24, flexWrap:"wrap" }}>
            {[["12 anos","Cabeleireira"],["7+ anos","Estética"],["100%","Dedicação"]].map(([n,l])=>(
              <div key={l}>
                <div className="serif" style={{ fontSize:28, color:"var(--gold)", fontWeight:300 }}>{n}</div>
                <div style={{ fontSize:9, letterSpacing:"2px", textTransform:"uppercase", color:"#555", marginTop:4 }}>{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
 
      {/* Trajetória — texto completo */}
      <section style={{ background:"var(--off-white)", padding:isMobile?"56px 24px":"90px clamp(24px,6vw,80px)" }}>
        <div style={{ maxWidth:800, margin:"0 auto" }}>
          <div style={{ marginBottom:48 }}>
            <SectionEyebrow>A Minha História</SectionEyebrow>
            <h2 className="serif" style={{ fontSize:"clamp(28px,4vw,44px)", fontWeight:300, lineHeight:1.15, marginBottom:8 }}>
              Uma Jornada de <em style={{ color:"var(--gold)", fontStyle:"italic" }}>Propósito</em>
            </h2>
            <Divider />
          </div>
 
          {/* Story paragraphs */}
          {[
            "Minha história na área da beleza começou há muitos anos, quando iniciei minha carreira como cabeleireira, profissão que exerci durante 12 anos. Foi ali que nasceu o meu amor por cuidar de pessoas e ajudar mulheres a se sentirem mais confiantes e bonitas.",
            "Mas foi após o nascimento da minha primeira filha que a minha vida tomou um novo rumo. Naquele momento, senti no coração o desejo de buscar algo diferente: uma profissão que me permitisse ter mais qualidade de vida, liberdade financeira e tempo para estar presente na vida da minha família.",
            "Foi então que decidi entrar de vez na área da estética. Ao longo dessa jornada, continuei me preparando e buscando crescimento. Cheguei a me formar em Administração, mas sempre com o coração e a dedicação voltados para o universo da beleza.",
            "Alguns anos depois, conheci o mundo das sobrancelhas — e foi ali que tudo mudou. Me encantei profundamente por essa área e descobri que trabalhar com sobrancelhas vai muito além da estética: é sobre transformar olhares, resgatar autoestima e revelar a beleza única de cada mulher.",
          ].map((p, i) => (
            <p key={i} style={{ fontSize:isMobile?14:15, fontWeight:300, color:"var(--gray)", lineHeight:2, marginBottom:24, animation:`fadeUp 0.6s ease ${i*0.1}s both` }}>{p}</p>
          ))}
 
          {/* Highlight quote */}
          <div style={{ margin:"40px 0", padding:"28px 32px", borderLeft:"3px solid var(--gold)", background:"rgba(201,168,76,0.04)" }}>
            <p className="serif" style={{ fontSize:isMobile?20:26, fontWeight:300, color:"var(--black)", lineHeight:1.6, fontStyle:"italic" }}>
              "Hoje posso dizer com orgulho que vivo de sobrancelhas."
            </p>
          </div>
 
          <p style={{ fontSize:isMobile?14:15, fontWeight:300, color:"var(--gray)", lineHeight:2, marginBottom:40 }}>
            Atualmente moro em Portugal, sou casada, mãe de duas filhas e tenho o meu próprio espaço, onde realizo atendimentos personalizados, sempre priorizando o cuidado, a naturalidade e a harmonia de cada rosto.
          </p>
 
          {/* Services list */}
          <div style={{ padding:"32px 28px", background:"var(--white)", border:"1px solid var(--light-gray)", marginBottom:40 }}>
            <div style={{ fontSize:10, letterSpacing:"4px", textTransform:"uppercase", color:"var(--gold)", marginBottom:20 }}>Procedimentos que Realizo</div>
            <ul style={{ listStyle:"none", display:"flex", flexDirection:"column", gap:12 }}>
              {procedures.map((item, i) => (
                <li key={i} style={{ display:"flex", gap:12, fontSize:isMobile?13:14, fontWeight:300, color:"var(--black)", lineHeight:1.6 }}>
                  <span style={{ color:"var(--gold)", flexShrink:0 }}>◆</span>{item}
                </li>
              ))}
            </ul>
          </div>
 
          <p style={{ fontSize:isMobile?14:15, fontWeight:300, color:"var(--gray)", lineHeight:2 }}>
            Além dos atendimentos, também sou criadora do método <strong style={{ fontWeight:500, color:"var(--black)" }}>"Sobrancelhas Perfeitas"</strong>, através do qual ensino outras mulheres a aprenderem uma profissão e a também conquistarem sua independência através do universo das sobrancelhas.
          </p>
        </div>
      </section>
 
      {/* Propósito — citação final em fundo escuro */}
      <section style={{ background:"var(--black)", padding:isMobile?"56px 24px":"80px clamp(24px,6vw,80px)" }}>
        <div style={{ maxWidth:720, margin:"0 auto", textAlign:"center" }}>
          <div className="serif" style={{ fontSize:isMobile?18:22, fontWeight:300, color:"#aaa", lineHeight:1.9, fontStyle:"italic" }}>
            "Hoje, mais do que uma profissão, a estética se tornou o meu propósito: transformar vidas, elevar a autoestima e mostrar que quando uma mulher se sente bem consigo mesma, tudo ao seu redor também se transforma."
          </div>
          <div style={{ width:60, height:1, background:"var(--gold)", margin:"32px auto 0", opacity:0.5 }} />
          <div style={{ fontSize:11, letterSpacing:"3px", textTransform:"uppercase", color:"var(--gold)", marginTop:16 }}>Elis Sousa</div>
        </div>
      </section>
 
      {/* CTA */}
      <div style={{ background:"var(--off-white)", padding:isMobile?"52px 24px":"80px clamp(24px,6vw,80px)", textAlign:"center", borderTop:"1px solid var(--light-gray)" }}>
        <SectionEyebrow>Pronta para Começar?</SectionEyebrow>
        <h2 className="serif" style={{ fontSize:"clamp(24px,3vw,40px)", fontWeight:300, marginBottom:20 }}>Agende a sua <em style={{ color:"var(--gold)", fontStyle:"italic" }}>Consulta</em></h2>
        <p style={{ fontSize:13, fontWeight:300, color:"var(--gray)", maxWidth:440, margin:"0 auto 28px", lineHeight:1.8 }}>Estou disponível para recebê-la e criar juntas um plano de tratamento personalizado.</p>
        <GoldBtn onClick={() => { setPage("home"); setTimeout(() => document.getElementById("contacto")?.scrollIntoView({behavior:"smooth"}), 100); }}>Marcar Consulta</GoldBtn>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   FOOTER
───────────────────────────────────────────── */
function Footer({ setPage }) {
  const isMobile = useIsMobile();
  return (
    <footer style={{ background:"var(--black)", borderTop:"1px solid #1a1a1a", padding:isMobile?"48px 24px 28px":"56px clamp(24px,6vw,80px) 32px" }}>
      <div style={{ display:"grid", gridTemplateColumns:isMobile?"1fr 1fr":"2fr 1fr 1fr 1fr", gap:isMobile?"32px 24px":60, paddingBottom:40, borderBottom:"1px solid #1e1e1e", marginBottom:28 }}>
        <div style={{ gridColumn:isMobile?"1/-1":"auto" }}>
          <div style={{ marginBottom:16 }}>
            <img src={LOGO_SRC} alt="Elis Sousa" style={{ height:72, width:72, filter:LOGO_FILTER, objectFit:"cover", display:"block", borderRadius:"50%" }} />
          </div>
          <p style={{ fontSize:12, fontWeight:300, color:"#444", lineHeight:2, maxWidth:260, marginBottom:20 }}>O lugar onde a sua beleza encontra o cuidado que merece.</p>
           <div style={{ display:"flex", gap:10 }}>
            <a href="https://www.instagram.com/elissousaoficial?igsh=YWVyZm1rNGNyM2o3" target="_blank" rel="noreferrer" style={{ width:44, height:44, border:"1px solid var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", textDecoration:"none", transition:"background 0.3s", borderRadius:4 }}
              onMouseEnter={e => e.currentTarget.style.background="rgba(201,168,76,0.15)"}
              onMouseLeave={e => e.currentTarget.style.background="transparent"}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill="#C9A84C" stroke="none"/>
              </svg>
            </a>
          </div>
        </div>
        {[
          { title:"Serviços", links:["Sobrancelhas","Olhos","Lábios","Pestanas", "Tratamentos Faciais", "Depilação", "Remoções"] },
          { title:"Navegação", links:["Home","Cursos","Sobre Mim"] },
          { title:"Contacto", links:["R. 25 de Abril n.º 326/B","Gondomar 4420-068","925 974 687","elissousa038@gmail.com"] },
        ].map(col=>(
          <div key={col.title}>
            <div style={{ fontSize:9, letterSpacing:"4px", textTransform:"uppercase", color:"var(--gold)", marginBottom:16 }}>{col.title}</div>
            {col.links.map(l=><div key={l} style={{ fontSize:11, fontWeight:300, color:"#444", marginBottom:9, lineHeight:1.6 }}>{l}</div>)}
          </div>
        ))}
      </div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12 }}>
        <div style={{ width:80, height:1, background:"linear-gradient(to right, var(--gold), transparent)" }} />
        <span style={{ fontSize:10, color:"#2a2a2a", letterSpacing:1, textAlign:"center" }}>© 2025 Elis Sousa Micropigmentação</span>
        <div style={{ width:80, height:1, background:"linear-gradient(to left, var(--gold), transparent)" }} />
      </div>
    </footer>
  );
}

/* ─────────────────────────────────────────────
   APP ROOT
───────────────────────────────────────────── */
export default function App() {
  const [page, setPage] = useState("home");
  useEffect(() => { window.scrollTo(0,0); }, [page]);
  return (
    <>
      <style>{globalStyles}</style>
      <Navbar page={page} setPage={setPage} />
      <main style={{ minHeight:"100vh" }}>
        {page==="home" && <HomePage setPage={setPage} />}
        {page==="cursos" && <CoursesPage setPage={setPage} />}
        {page==="sobre" && <SobrePage setPage={setPage} />}
      </main>
      <Footer setPage={setPage} />
    </>
  );
}




